import { render, staticRenderFns } from "./purchaseConfirm.vue?vue&type=template&id=dca30d58&scoped=true"
import script from "./purchaseConfirm.vue?vue&type=script&lang=js"
export * from "./purchaseConfirm.vue?vue&type=script&lang=js"
import style0 from "./purchaseConfirm.vue?vue&type=style&index=0&id=dca30d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca30d58",
  null
  
)

export default component.exports